module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_h('div', {
    staticClass: "page home"
  }, [_h('p', ["Robot D is Adam Drobotij, a web developer with 15 years of experience interpreting great designs and\n\t\t\tmaking them shine on the interactive page. He is skilled with many modern web programming\n\t\t\tlanguages (Javascript, ", _h('span', {
    staticClass: "smallcaps"
  }, ["HTML5"]), ", ", _h('span', {
    staticClass: "smallcaps"
  }, ["CSS3"]), " and a\n\t\t\tfew ", _h('span', {
    staticClass: "smallcaps"
  }, ["CSS"]), "-processors like ", _h('span', {
    staticClass: "smallcaps"
  }, ["SASS"]), " and\n\t\t\tPost-", _h('span', {
    staticClass: "smallcaps"
  }, ["CSS"]), ",\n\t\t\t", _h('span', {
    staticClass: "smallcaps"
  }, ["LAMP"]), ", various front-end frameworks like\n\t\t\t", _h('a', {
    attrs: {
      "href": "https://facebook.github.io/react/"
    }
  }, ["React"]), ",\n\t\t\t", _h('a', {
    attrs: {
      "href": "http://angularjs.org/"
    }
  }, ["Angular"]), " and ", _h('a', {
    attrs: {
      "href": "https://jquery.com/"
    }
  }, ["JQuery"]), ") but Adam’s\n\t\t\texpertise lies in applying his art and animation education to the site-building process; resulting in a\n\t\t\tslick, intuitive experience for the user.\n\t\t\tLearning new skills is always interesting to him. He built this site to learn\n\t\t\t", _h('a', {
    attrs: {
      "href": "https://vuejs.org/"
    }
  }, ["VueJS"]), " and refresh his memory\n\t\t\tof ", _h('a', {
    attrs: {
      "href": "https://threejs.org"
    }
  }, ["ThreeJS"]), ".\n\t\t\tLately, he’s been playing with Graphics Shaders and ", _h('a', {
    attrs: {
      "href": "https://unity3d.com/"
    }
  }, ["Unity3D"]), "."]), " ", _h('p', ["Adam would love to work with you. Connect with him on ", _h('a', {
    attrs: {
      "href": "http://www.linkedin.com/in/adamdrobotij"
    }
  }, ["LinkedIn"]), "."]), " ", _h('p', ["Also, if you would just like to talk about video games, football or food… he’s down for that."])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9fe9c90a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 26
// module chunks = 1